import { useState, useEffect } from 'react';
// import FormBuilder from "../../components/Builders/FormBuilder";
// import Tabs from "../../components/Navigation/Tabs";
// import { InnerPageProps } from "../../constants/types/componentsTypes/InnerpageTypes";
// import { formsMetadata } from "../../constants/constants";
// import TabsWithHeaders from "../../components/Navigation/TabsWithHeaders";
// import ListBuilder from "../../components/Builders/ListBuilder";

// import Table from "../../components/DataDisplay/Tables/DataTable/Table";
// import { Transition } from "@headlessui/react";
// import InnerPageToggelButton from "../../components/General/InnerPageToggelButton";
import PageHeder from '../Headers/PageHeader';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { useQuery } from '@wajeez-web/components/helpers';
import { IconType } from 'react-icons';
import { useCommonSelector } from '@wajeez-web/stores/common';
import { Transition } from '@headlessui/react';
import { updateUrlQuery } from '@wajeez-web/core/utils';

// export interface TableActionType {
//   title: string;
//   permission: string;
//   endpoint: string;
//   type: 'modal' | 'link' | 'request' | 'dependentAction';
//   methode?: 'post' | 'delete' | 'put' | 'get';
//   modalType?: 'form' | 'list;';
//   keyname?: string;
//   action?: (id: string, row: any) => void;
//   dependentActionValues?: {
//     true: { label?: string; action: (id: string) => void };
//     false: { label?: string; action: (id: string) => void };
//   };
// }
// export enum InnerPageContentValueTypes {
//   FORM = 'form',
//   LIST = 'list',
//   DATATABLE = 'datatable',
//   PAGINATED_TABLE = 'paginatedTable',
// }

// export interface InnerPageContent {
//   values: {
//     type: InnerPageContentValueTypes;
//     subtitle?: string;
//     endpoint: string;
//     data?: any;
//     values?: any;
//     hederExtraComponent?: { element: JSX.Element; permission?: string }[];
//     withoutCard?: boolean;
//     tableActions?: TableActionType[];
//     tableExtra?: {
//       tableUrl: string;
//     };
//     tableFetchDataAction?: (
//       body: DataTableApiBody,
//       canceller: AbortController
//     ) => Promise<any>;
//     getFormData?: (props: any) => void;
//     formExtra?: {
//       extraFieldsValues?: ExtraFieldsValuesProps;
//       extraFields?: ContentItemExtraFieldsKeys[];
//       requiredFields?: ContentItemRequierdKeys[];
//       defaultNarratorId?: number;
//       hasSubmitButton?: boolean;
//     };
//     listExtra?: ListBuilderProps;
//   }[];
// }

export interface InnerPageProps {
  title: string;
  desc?: string;
  tabs: { text: string; disabled: boolean; desc?: string; Icon?: IconType }[];
  tabsType?: 'fullWidth' | 'normal';
  // content: InnerPageContent[];
}

const InnerPageLayoutContiner = ({
  title,
  desc,
  tabs,
  // content,
  tabsType = 'normal',
}: InnerPageProps) => {
  const query = useQuery();

  const [selectedTab, setSelectedTab] = useState(
    query.get('tab') ? Number(query.get('tab')) : 0
  );
  const { innerPageSideBarCollapsed } = useCommonSelector(
    (state) => state.common.settings
  );
  const [isTableSelectedTab, setIsTableSelectedTab] = useState(false);

  const location = useLocation();

  const { t } = useTranslation();

  useEffect(() => {
    setSelectedTab(query.get('tab') ? Number(query.get('tab')) : 0);
  }, [location.pathname]);

  useEffect(() => {
    // add query param to url
    window.history.pushState(
      {},
      '',
      updateUrlQuery(window.location.href, 'tab', selectedTab.toString())
    );
  }, [selectedTab]);

  const selectTab = (selected: number) => {
    setSelectedTab(selected);
  };

  return (
    <div
      className={`${
        tabsType !== 'fullWidth' ? 'flex' : 'grid grid-cols-4'
      }  overflow-hidden bg-wihte h-inner-screen `}
    >
      <Transition
        className={'h-full'}
        show={!innerPageSideBarCollapsed}
        // enter="transition-all ease duration-1000 transform"
        // enterFrom="w-0"
        // enterTo="w-full"
        // leave="transition-all ease   transform"
        // leaveFrom="w-full"
        // leaveTo="w-0"
      >
        <div
          className={`h-full  overflow-hidden ${
            tabsType === 'fullWidth'
              ? ''
              : 'w-52 bg-white border-e shadow-lg border-warmGray-200'
          }`}
        >
          {tabs &&
            (tabsType === 'fullWidth' ? (
              <div className="md:col-span-1  h-full  flex flex-grow  overflow-hidden">
                {/* <TabsWithHeaders
                  header={title}
                  tabs={tabs}
                  selectedTab={selectedTab}
                  setSelectedTab={selectTab}
                /> */}
              </div>
            ) : (
              <div className="py-4 divide-y   space-y-4">
                <div className=" px-2 text-center">
                  <h3 className="text-lg font-bold  text-gray-900">
                    {title.split('"')[0]}
                  </h3>
                  {title.split('"')[1] && (
                    <h3 className="text-base font-semibold  text-gray-900">
                      " {title.split('"')[1]} "
                    </h3>
                  )}
                  {/* <p className="mt-1 text-sm text-gray-600">{desc}</p> */}
                </div>
                {/* <Tabs
                  tabs={tabs}
                  selectedTab={selectedTab}
                  setSelectedTab={selectTab}
                /> */}
              </div>
            ))}
        </div>
      </Transition>
      <div
        className={`h-full  md:mt-0 flex-1  ${
          innerPageSideBarCollapsed ? 'col-span-4' : 'col-span-3'
        } flex-grow overflow-y-auto focus:outline-none space-y-10  `}
      >
        <div className="grid grid-cols-3 h-full">
          <div
            className={`col-span-${
              tabsType === 'fullWidth' ? '3' : '3'
            } sm:grid-cols-3`}
          >
            {/* {content[selectedTab]?.values.map((item, key) => {
              switch (item.type) {
                case 'form':
                  return (
                    <div key={key} className="p-6 sm:py-8 sm:px-10">
                      {' '}
                      <FormBuilder
                        requiredFeilds={item.formExtra?.requiredFields}
                        hasSubmitButton={item.formExtra?.hasSubmitButton}
                        extraFields={item.formExtra?.extraFields}
                        defaultNarratorId={item.formExtra?.defaultNarratorId}
                        extraFeildsFormValues={
                          item.formExtra?.extraFieldsValues
                        }
                        hasToggelButton={true}
                        withoutCard={item.withoutCard}
                        formValues={item.values}
                        key={key}
                        title={
                          item.data?.title
                            ? t(
                                `general.${
                                  item.data
                                    ? item.data.title
                                    : formsMetadata[item.endpoint].title || ''
                                }`,
                                (item.data
                                  ? item.data.title
                                  : formsMetadata[item.endpoint].title) || ''
                              )
                            : ''
                        }
                        desc={
                          item.data?.description
                            ? t(
                                `general.${
                                  item.data
                                    ? item.data.description
                                    : formsMetadata[item.endpoint].description
                                }`,
                                (item.data
                                  ? item.data.description
                                  : formsMetadata[item.endpoint].description) ||
                                  ''
                              )
                            : ''
                        }
                        action={(val) => {
                          item.getFormData && item.getFormData(val);
                        }}
                        rows={
                          item.data
                            ? item.data.fields
                            : formsMetadata[item.endpoint].fields
                        }
                      />
                    </div>
                  );
                case 'list':
                  return (
                    <div key={key} className="p-6 sm:py-8 sm:px-10 h-full">
                      {item.listExtra && (
                        <ListBuilder
                          hasToggelButton={true}
                          orderAction={item.listExtra.orderAction}
                          getData={item.listExtra?.getData || (() => {})}
                          onAssign={item.listExtra?.onAssign}
                          onDelete={item.listExtra?.onDelete}
                          data={item.listExtra?.data}
                          editRow={item.listExtra?.editRow}
                          title={tabs[selectedTab]?.text || ''}
                          rowActions={item.listExtra?.rowActions || []}
                          showAs={item.listExtra?.showAs || 'rows'}
                          addAction={item.listExtra?.addAction}
                          listEndpoint={item.endpoint}
                        />
                      )}
                    </div>
                  );

                case 'datatable':
                  return (
                    <div key={key} className="py-6">
                      <div className="p-l space-y-10 py-8 sm:pl-10 h-full pe-3 ">
                        <PageHeder
                          withoutCard={true}
                          endSideComponent={item.hederExtraComponent}
                          title={
                            <div className="ms-2 lg:ms-0 text-2xl flex align-middle font-bold space-s-2 tracking-tight leading-none  ">
                              <InnerPageToggelButton />
                              <div className=" mt-1">
                                {tabs[selectedTab]?.text}
                              </div>
                            </div>
                          }
                        />
                        <Table
                          key={item.tableExtra?.tableUrl + ' ' + key}
                          tableEndpoint={item.tableExtra?.tableUrl || ''}
                          tableActions={item.tableActions}
                          tableFetchDataAction={item.tableFetchDataAction}
                        />
                      </div>
                    </div>
                  );
                default:
                  return null;
              }
            })} */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default InnerPageLayoutContiner;
